import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useSubmitBranchWithCode = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const submitBranchWithCode = (OriginGuid, codeValue, handleClose) => {
    axiosClient
      .post(`Product/Branch/InsertWithCode`, {
        OriginGuid,
        Code: codeValue,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(res?.data?.message, { variant: 'success' });
          handleClose();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };
  return [submitBranchWithCode, loading];
};

export default useSubmitBranchWithCode;
